import __ from "src/utils/Translations";
import { HistoryAction } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

export default (action: HistoryAction) => {
  if (action === HistoryAction.CREATION) {
    return __("Utworzenie wniosku");
  }

  if (action === HistoryAction.EDITION) {
    return __("Edycja");
  }

  if (action === HistoryAction.CANCELLATION_AFTER_PATTERN_ASSIGNMENT_CHANGE) {
    return __("Wniosek anulowany po zmianie wzorca");
  }

  if (
    action ===
    HistoryAction.CANCELLATION_AFTER_ABSENCE_TYPE_SUBMIT_LIMITATION_CHANGE
  ) {
    return __("Wniosek anulowany po zmianie ograniczenia");
  }

  return __("Zmiana statusu");
};
